import { ChangeDetectionStrategy,Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormField, MatHint, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';

export interface ConsolidateUserDialogData {
    anonymousStoreUSerId: string;
}

export interface ConsolidateUserDialogResult {
    targetStoreUserId: string;
}

@Component({
    templateUrl: './consolidate-user-dialog.component.html',
    styleUrls: ['./consolidate-user-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, MatDialogContent, MatIcon, FormsModule, MatFormField, MatLabel, MatInput, MatHint, MatDialogActions, MatButton, MatDialogClose]
})
export class ConsolidateUserDialogComponent {
    dialogRef = inject<MatDialogRef<ConsolidateUserDialogComponent, ConsolidateUserDialogResult>>(MatDialogRef);
    data = inject<ConsolidateUserDialogData>(MAT_DIALOG_DATA);

    public targetStoreUserId: string;

    valid() {
        this.dialogRef.close({ targetStoreUserId: this.targetStoreUserId });
    }
}
